<nb-stepper orientation="horizontal" (stepChange)="onStepChange($event)" disableStepNavigation>
    <nb-step [label]="linkType">
        <ng-template #linkType>Load Product</ng-template>
        <div class="step-content-wrapper">
            <div class="stepper-actions">
                <ng-container *ngIf="showPlaceholder;else placeHolder">
                    <nb-tabset fullWidth class="stepper-tabs">
                        <nb-tab tabTitle="Load Existing Product">
                            <kve-product-editor-dialog [selectedCell]="cell" [section]="section" (selectedProduct)="selectProduct($event)"></kve-product-editor-dialog>
                        </nb-tab>
                        <nb-tab tabTitle="Create New Product">
    
                        </nb-tab>
                    </nb-tabset>
                </ng-container>
                <ng-template #placeHolder>
                    <div class="image-container">
                        <img 
                          [src]="imgSrc"
                          (error)="onImageError()"
                          alt="Image placeholder"
                          *ngIf="!showPlaceholder"
                        />
                      </div>
                </ng-template>
                <!-- <nb-actions size="small">
                    <nb-action>Load Existing Product</nb-action>
                    <nb-action title="Existing Product"
                        class="popover-icon"
                        (click)="productDialog('exiting')">
                        <nb-icon icon="cloud-download-outline" pack="eva" title="Existing Product"></nb-icon>
                    </nb-action>
                    <nb-action>Create New Product</nb-action>
                    <nb-action title="New Product"
                        class="popover-icon"
                        (click)="productDialog('new')">
                        <nb-icon icon="plus-outline" pack="eva" title="New Product"></nb-icon>
                    </nb-action>
                </nb-actions> -->
            </div>
            <!-- <div class="preview-content" [attr.id]="cell.cellId">
                <div class="image-container">
                    <img 
                      [src]="imgSrc"
                      (error)="onImageError()"
                      alt="Image placeholder"
                      *ngIf="!showPlaceholder"
                    />
                    <ng-container *ngIf="showPlaceholder">
                        <svg 
                            width="100%" 
                            height="100%" 
                            xmlns="http://www.w3.org/2000/svg" 
                            class="placeholder">
                            <rect width="100%" height="100%" fill="#e0e0e0" />
                            <text x="50%" y="50%" font-size="16" fill="#333" text-anchor="middle" dy=".3em">Link Existing or Create New Product</text>
                          </svg>
                    </ng-container>
                  </div>
            </div> -->
            <div class="button-wrapper">
                <button nbButton disabled nbStepperNext size="small" class="btn-right">prev</button>
                <button nbButton nbStepperNext size="small">next</button>
            </div>
        </div>
    </nb-step>
    <nb-step *ngFor="let contentElement of contentElements" 
        [label]="getEnumValue(contentElement)">
        <div class="step-content-wrapper">
            <div class="preview-content" [attr.id]="cell.cellId">
                <p>{{contentElement.name}}</p>
            <pre [innerHTML]="contentElement | json"></pre>
            </div>
            
            <div class="button-wrapper">
                <button nbButton [disabled]="firstStep" nbStepperPrevious size="small" class="btn-right">prev</button>
                <button nbButton nbStepperNext size="small">next</button>
                <button nbButton size="small" status="primary" (click)="onSubmitContent()" [disabled]="!lastStep">Done<nb-icon icon="checkmark-outline" pack="eva" status="success"></nb-icon></button>
            </div>

        </div>

    </nb-step>
</nb-stepper>
